export default "/images/attendance-small.svg?0c4f8fb81c3ddbc5ccef763597dde406";